<template>
  <div class="container" id="event-groups-list">
    <p class="text-center py-4">Sichern Sie sich jetzt einen Preisvorteil, indem Sie ein 2er Ticket für das Filmfest St. Anton kaufen.</p>
    <div class="accordion mb-5" id="eventRows">
      <EventGroupListItem v-for="(eventrow, id) in subscriptions" v-bind:key="id" v-bind:data="eventrow"></EventGroupListItem>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-undef
var _cart = cart;

import EventGroupListItem from "@/components/EventGroupListItem";
export default {
  name: "EventGroupsList",
  components: {EventGroupListItem},
  data: function () {
    return {
      subscriptions: {},
      eventrows: {},
      cart: _cart,
    }
  },
  created() {
    const ttNameRegex = new RegExp('.*(Wahlabo).*');
    this.axios.get('https://ticketorganizer.eu/cms/public/ws/api-public/eventgroup/' + this.token + '/list/').then((res) => {
      res.data.forEach(elem => {
        this.axios.get('https://ticketorganizer.eu/cms/public/ws/api-public/eventgroup/' + this.token + '/listevents/'+elem.id).then((res2) => {
          elem.events = res2.data
          res2.data.forEach(event => {
            var tickettypes = Object.assign([], event.tickettypes).filter(tt => ttNameRegex.test(tt.name))
            event.tickettypes = tickettypes;
            var tickettypes_selectable = [];
            // eslint-disable-next-line no-unused-vars
            for (const [key, tt] of Object.entries(tickettypes)) {
              if(!tickettypes_selectable.some(el => el.shopname === tt.shopname)) {
                tickettypes_selectable.push(tt);
              }
            }
            event.tickettypes_selectable = tickettypes_selectable;
            event.event_group_id = elem.id;
            // eslint-disable-next-line no-unused-vars
            for (const [key, tt] of Object.entries(tickettypes)) {
              if(tt.freeContingent == null) {
                tt.freeContingent = true;
              }
              this.cart.tickettypes[tt.id] = tt;
            }
          })
          if(elem.tags === "subscription") {
            elem.events.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(a.date_from) - new Date(b.date_from);
            });
            this.$set(this.subscriptions, elem.id, elem);
          } else if (elem.tags === "eventrow") {
            elem.events.sort(function(a,b){
              // Turn your strings into dates, and then subtract them
              // to get a value that is either negative, positive, or zero.
              return new Date(a.date_from) - new Date(b.date_from);
            });
            this.$set(this.eventrows, elem.id, elem);
          }
        })
      });
    })
  }
}
</script>

<style scoped>
#event-groups-list {
  min-height: calc(100vh - 543px);
}
</style>